/**
 * 系统管理  学习卡管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学习卡管理</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search" @submit.native.prevent>
      <el-form-item label="搜索：">
        <el-input size="small" v-model="queryParams.className" placeholder="输入班级名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.name" placeholder="输入学员姓名"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.idcard" placeholder="输入身份证号"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.phone" placeholder="输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select size="small" v-model="queryParams.sfzfxxk" placeholder="请选择是否作废" clearable>
          <el-option label="是" :value="1" :key="1" />
          <el-option label="否" :value="0" :key="0" />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
<!--        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>-->
      </el-form-item>
    </el-form>


    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
      <el-table-column prop="className" label="班级名称"/>
      <el-table-column prop="name" label="姓名" width="150"/>
      <el-table-column prop="phone" label="手机号" width="150"/>
      <el-table-column prop="idcard" label="身份证号"/>
      <el-table-column prop="subjectName" label="科目"/>
      <el-table-column prop="sfzfxxk" label="是否作废" width="150">
        <template slot-scope="scope">
          {{ scope.row.sfzfxxk == 1 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">

          <el-tooltip
            class="item"
            effect="dark"
            content="恢复"
            placement="top"
            v-if="scope.row.sfzfxxk == 1"
          >
            <el-button
              size="mini"
              type="success"
              icon="el-icon-finished"
              @click="handleVoid(0, scope.row)"
            >
            </el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="作废"
            placement="top"
            v-if="scope.row.sfzfxxk == 0"
          >
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="handleVoid(1, scope.row)"
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

  </div>
</template>

<script>
import {getCourseMbList, addCourseMb, editCourseMb, deleteCourseMbById, queryCourseMbById} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import CourseManage from '../course/courseManage.vue'
import {formatInportData, timestampToTime} from "../../utils/util";
import {selectAreaTree} from "../../api/subjectTree";
import Template from "../../components/template.vue";
import {changeXxkStatus, queryXxkByPage} from "../../api/student";

export default {
  data() {
    return {
      add_index: 0,
      // 教室信息
      openCourse: false,
      courseList: [],

      loading: false, //是显示加载
      editFormShow: false, //控制编辑页面显示与隐藏
      title: '添加',
      queryParams: {
        page: 1,
        size: 10,
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      treeOptions: undefined,

    }
  },
  // 注册组件
  components: {
    Template,
    Pagination,
    CourseManage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.initData();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    formatInportData,
    timestampToTime,
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    initData() {
      this.getdata();
      this.selectAreaTree();
    },
    // 查询 科目树
    selectAreaTree() {
      selectAreaTree({}).then(res => {
        if (res.code == 200) {
          this.treeOptions = res.data;
        }
      })
    },
    // 获取营销渠道列表
    getdata() {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      queryXxkByPage(this.queryParams).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.data.content
          // 分页赋值
          this.pageparm = res.data.pageparm
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      this.getdata()
    },

    // 作废 / 恢复
    handleVoid(x, row) {
      this.$confirm('确定要' + (row.sfzfxxk == 0 ? '作废' : '恢复') + '该条数据吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          var params = {
            id: row.id,
            sfzfxxk: row.sfzfxxk == 0 ? 1 : 0
          }
          changeXxkStatus(params).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('操作失败，请稍后再试！')
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormShow = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/goods/learningCardManage.vue